import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './plugins'
import vuetify from './plugins/vuetify'
import {sync} from 'vuex-router-sync'
import axios from 'axios'

import i18n from '@/lang/lang';
import FlagIcon from 'vue-flag-icon'
import Auth from './settings/auth/Auth'
import VueSweetalert2 from 'vue-sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';
import * as VueGoogleMaps from 'vue2-google-maps'

import VueApexCharts from 'vue-apexcharts'
import movable from './statics/movableDialog';

//Import Froala Editor
import 'froala-editor/js/plugins.pkgd.min.js';
//Import third party plugins
import 'froala-editor/js/third_party/embedly.min';
import 'froala-editor/js/third_party/font_awesome.min';
import 'froala-editor/js/third_party/spell_checker.min';
import 'froala-editor/js/third_party/image_tui.min';
// Import Froala Editor css files.
import 'froala-editor/css/froala_editor.pkgd.min.css';

// Import and use Vue Froala lib.
import VueFroala from 'vue-froala-wysiwyg'
import CKEditor from '@ckeditor/ckeditor5-vue';









sync(store, router)
Vue.use(i18n)
Vue.use(Auth)
Vue.use(VueSweetalert2)
Vue.use(FlagIcon)
Vue.use(VueApexCharts)
Vue.use(movable);
Vue.use( CKEditor );

Vue.use(VueFroala)

Vue.component('apexchart', VueApexCharts)

Vue.config.productionTip = false

// Request interceptor for adding token to every request
axios.interceptors.request.use(request => {
  request.headers.common['Authorization'] = 'Bearer ' + Vue.auth.getToken()
  return request
})


new Vue({
  router,
  store,
  vuetify,
  i18n,
  render: h => h(App),
}).$mount('#app')
